import { Injectable } from '@angular/core';
import { siteSpecificData } from '../../../environments/site-specific-data';
import { UserSettingsService } from '@feature/user-settings/services/user-settings.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs';

const API_URL = siteSpecificData.apiUrlBase;
const MOJO_API_URL = siteSpecificData.mojoApiUrl;
const IDENTITY_SERVER_URL = siteSpecificData.identityServerApiUrl;
const OIDC_AUTHORITY = siteSpecificData.oidcClientConfiguration.authority;


//@Injectable()
@Injectable({
  providedIn: 'root'
})
export class UrlBuilderService {

  private baseMojoFormsUrl: string;


  constructor(private readonly userSettingsService: UserSettingsService) {

    userSettingsService.getUserSettings().subscribe((settings) => {
      this.baseMojoFormsUrl = settings.MojoFormsBaseUrl;
    });


  }
  getUrl(path: string) {
    return API_URL + path;
  }

  getMojoApiUrlObservable(path: string): Observable<string> {
    return this.userSettingsService.getUserSettings().pipe(map(us => `${us.MojoFormsBaseUrl}api/${path}`));
  }

  getMojoApiUrl(path: string): string {

    if (this.baseMojoFormsUrl == undefined || this.baseMojoFormsUrl === '')
    {
      return MOJO_API_URL + path;
    } else
    {
      return this.baseMojoFormsUrl + 'api/' + path;
    }
  }

  getMojoFormsMyActivitiesUrl(): string {
    return this.baseMojoFormsUrl + 'Activity';
  }

  getWorksUrl(): string {
    return this.baseMojoFormsUrl + 'works';
  }

  getMojoFormsNewActivitiesUrl(): string {
    return this.baseMojoFormsUrl + 'Activity/NewActivity';
  }

  getMojoFormsMyActivitiesApiUrl(): string {
    return this.getMojoApiUrl('mydashboard/activities');
  }

  getIdentityServerUrl(path: string): string {
    return IDENTITY_SERVER_URL + path;
  }

  getOidcClientAuthorityUrl(path: string): string {
    return  OIDC_AUTHORITY + path;
  }

  getRecordActivityUrl(): string {
    return this.getOidcClientAuthorityUrl('api/recordactivity');
  }

  getEditActivityUrl(): string {
    return this.baseMojoFormsUrl + 'Activity/EditActivity?formId=';
  }
}
